// Constants for different requests for current reducer
export default {
  employeeInfo: 'EMPLOYEE_INFO',
};
